import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

const useKlydoDeleteLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (labelId: string) => {
      return await klydoApiClient.deleteKlydoLabel(labelId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-labels"] });
    },
    onError: (error) => {
      console.error("Failed to delete klydo label:", error);
    },
  });
};

export default useKlydoDeleteLabelMutation;
